import type { TQueryConstructor } from '@hozana/api/types'

import { STATS } from 'modules/home/constants'

export type TGetStatisticsData = {
  latestUsers: string[]
} & Record<STATS, number>

export const getStatisticsQuery: TQueryConstructor<void, TGetStatisticsData> = () => ({
  queryKey: 'statistics',
  url: '/statistics',
  headers: { 'Cache-Control': 'public' },
})
